import { useMyPermissions } from "modules/my-permissions";
import Router from "next/router";
import React, { CSSProperties, FormEvent, useState } from "react";
import { api } from "shared/api";
import { Button, Fieldset, Input } from "shared/ui";

export interface ICompanySlugForm {
  companySlug: string;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const CompanySlugForm = (props: ICompanySlugForm) => {
  const permissions = useMyPermissions(props.companySlug);

  const company = api.company.useCompanyGet(props.companySlug);

  const [value, setValue] = useState<string>();

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!company.data || !value) return;
    await api.company.companyChangeSlug(company.data.id, { value });
    await company.mutate();
    await Router.replace({ query: { ...Router.query, company: value } });

    setValue(undefined);
  };

  return (
    <form className={props.className} style={props.style} id={props.htmlId} onSubmit={onSubmit}>
      <Fieldset disabled={!permissions?.company.general.update}>
        <Fieldset.Content>
          <Fieldset.Title>Ссылка на компанию</Fieldset.Title>
          <Fieldset.Subtitle>
            Можете задать уникальную ссылку для своей компании. Она будет видна в части ссылки для приглашения
            сотрудников.
          </Fieldset.Subtitle>
          <Input
            style={{ maxWidth: 300 }}
            prefix="control.online/"
            value={value ?? company.data?.slug}
            onChange={(e) => setValue(e.target.value)}
            tabIndex={-1}
          />
        </Fieldset.Content>
        <Fieldset.Footer>
          <Fieldset.Footer.Status>Максимум 48 символов</Fieldset.Footer.Status>
          <Fieldset.Footer.Actions>
            <Button size="small" htmlType="submit" disabled={!value} tabIndex={-1}>
              Сохранить
            </Button>
          </Fieldset.Footer.Actions>
        </Fieldset.Footer>
      </Fieldset>
    </form>
  );
};

CompanySlugForm.defaultProps = {};
